export {
  DEFAULT_NATS_URL,
  DEFAULT_STREAM_NAME,
  priceSubject,
  lastPriceFromKline,
  connectNatsJetStream,
  consumePriceUpdates,
  drainNats,
  acquireGlobalNatsJetStream,
  releaseGlobalNatsJetStream,
  subscribeSymbol,
  resolveNatsAuthToken,
  getDevNatsToken,
} from "./client";

export type {
  PriceKlinePayload,
  NatsLiveHandle,
  ResolveNatsAuthTokenParams,
  SubscribeSymbolOptions,
} from "./client";

import type { PriceKlinePayload, NatsLiveHandle, SubscribeSymbolOptions } from "./client";
import { subscribeSymbol } from "./client";

/** @deprecated Prefer `subscribeSymbol(symbol, onUpdate, options)`. */
export type SubscribeLivePriceKlineOptions = SubscribeSymbolOptions & { stockId: string };

/** @deprecated Prefer `subscribeSymbol(stockId, onUpdate, options)`. */
export async function subscribeLivePriceKline(
  options: SubscribeLivePriceKlineOptions,
  onKline: (data: PriceKlinePayload) => void
): Promise<NatsLiveHandle> {
  const { stockId, ...rest } = options;
  return subscribeSymbol(stockId, onKline, rest);
}
